// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r1-0";